// Phase 11d.5 — App Store + Play Store install badges (non-clickable, "Coming Q2 2026")
// Approximate the real badges with styled <div> elements so we don't ship trademarked SVGs.
import PropTypes from "prop-types";
import { Apple, Play } from "lucide-react";

function AppStoreBadge() {
  return (
    <div className="inline-flex items-center gap-2 rounded-xl bg-black text-white px-3.5 py-2 cursor-default select-none" data-testid="badge-app-store">
      <Apple size={22} strokeWidth={1.5} />
      <div className="leading-tight">
        <div className="text-[8px] uppercase tracking-wider opacity-80">Download on the</div>
        <div className="text-[15px] font-semibold tracking-tight -mt-0.5">App Store</div>
      </div>
    </div>
  );
}

function PlayStoreBadge() {
  return (
    <div className="inline-flex items-center gap-2 rounded-xl bg-black text-white px-3.5 py-2 cursor-default select-none" data-testid="badge-play-store">
      <Play size={20} strokeWidth={1.5} className="rotate-0" />
      <div className="leading-tight">
        <div className="text-[8px] uppercase tracking-wider opacity-80">Get it on</div>
        <div className="text-[15px] font-semibold tracking-tight -mt-0.5">Google Play</div>
      </div>
    </div>
  );
}

function ComingSoonPill() {
  return (
    <span className="inline-flex items-center rounded-full bg-amber-50 ring-1 ring-amber-200 px-2 py-0.5 text-[9.5px] font-semibold tracking-wider uppercase text-amber-700">
      Coming Q2 2026
    </span>
  );
}

export function AppStoreBadges({ stacked = false, withPill = true, className = "" }) {
  return (
    <div className={`${stacked ? "flex flex-col items-start" : "flex items-center"} gap-2 ${className}`} data-testid="app-store-badges">
      <div className="flex items-center gap-2 flex-wrap">
        <AppStoreBadge />
        <PlayStoreBadge />
      </div>
      {withPill && <ComingSoonPill />}
    </div>
  );
}

AppStoreBadges.propTypes = {
  stacked: PropTypes.bool,
  withPill: PropTypes.bool,
  className: PropTypes.string,
};
